import { ASMHomePage } from '@/constants/constants';
import AppSettingsContext from '@/contexts/AppSettingsContext';
import { faBird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const EarlyBirdClosed: FC = () => {
    const navigate = useNavigate();
    const { data: appSettings } = useContext(AppSettingsContext);
    
    const earlyBirdRegistrationEndDate = appSettings?.earlyBirdRegistrationEndDate
        ? DateTime.fromISO(appSettings.earlyBirdRegistrationEndDate)
        : undefined;

    const handleGoToRegistration = () => {
        navigate('/registration');
    };

    const handleGoToHomepage = () => {
        window.location.href = ASMHomePage;
    };

    return (
        <Container maxWidth="md">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    py: 4,
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: { xs: 3, sm: 5 },
                        textAlign: 'center',
                        maxWidth: 800,
                        width: '150%',
                    }}
                >
                    <Box
                        sx={{
                            mb: 3,
                            color: 'primary.main',
                        }}
                    >
                        <FontAwesomeIcon icon={faBird} size="4x" />
                    </Box>

                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: {
                                xs: '1.75rem',
                                sm: '2.25rem',
                                md: '2.5rem',
                            },
                            fontWeight: 600,
                            mb: 2,
                            color: 'text.primary',
                        }}
                    >
                        Early Bird Registration Has Closed
                    </Typography>

        

                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: {
                                xs: '1rem',
                                sm: '1.125rem',
                            },
                            mb: 4,
                            color: 'text.secondary',
                        }}
                    >
                        Exclusive Early Registration has now closed, Early Bird registration will open in <strong>October</strong>.
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            variant="outlined"
                            color="primary"
                            size="large"
                            onClick={handleGoToHomepage}
                            sx={{
                                px: 4,
                                py: 1.5,
                            }}
                        >
                            Return to Homepage
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={handleGoToRegistration}
                            sx={{
                                px: 4,
                                py: 1.5,
                            }}
                        >
                            Go to Regular Registration
                        </Button>
                  
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default EarlyBirdClosed;
